import { useContext, useEffect, useState } from "react";
import style from "./index.module.scss";
import { encode } from "js-base64";
import { LandingLoginContext } from "../../../context/LandingLoginContext";
import Modal from "@/src/views/components/Modal";
import Paper from "@/src/views/components/Paper";
import Typography from "@/src/views/components/Typography";
import SubstractIcon from "@/src/views/components/Icon/icons/SubstractIcon";
import ChecklistBrilink from "@/src/views/components/Icon/icons/ChecklistBrilink";
import Textfield from "@/src/views/components/Inputs/Textfield";
import Button from "@/src/views/components/Button";
import { useDispatch, useSelector } from "react-redux";
import { postChangePasswordSvc } from "@/src/services/api/loginPage";
import Icon from "@/src/views/components/Icon";
import { loginAction, resetLoginData } from "@/src/application/actions/loginPage";
import { useDevice } from "@/src/services/hooks";
import { regex } from "@/src/services/utils/functions/regex";
import Cookies from "universal-cookie";
import { useRouter } from "next/router";

export default function ModalChangePassword() {
  const uuidRegex: RegExp = regex.uuid
  const device: "mobile" | "desktop" | undefined = useDevice();
  const router = useRouter()
  const dispatch = useDispatch()
  const {
    loginDatas,
    captchaContent,
  } = useSelector((stateRedux: any) => stateRedux.loginPage)
  const {
    passwordRules,
    modalChangePasswordState,
    setModalChangePasswordState,
    modalRouteToDashboardState,
    setModalRouteToDashboardState,
    changePasswordForm,
    setChangePasswordForm,
    newPasswordFulfilledRules,
    captchaValue,
  } = useContext(LandingLoginContext)

  const [isMaskPassword, setIsMaskPassword] = useState(true)
  const [isMaskConfirmPassword, setIsMaskConfirmPassword] = useState(true)
  const [loadingChangePassword, setLoadingChangePassword] = useState(false)

  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;

  const helperTextConfirmNewPassword = "Password tidak sama, mohon periksa kembali"

  const validConfirmNewPassword = 
    changePasswordForm.confirmNewPassword &&
    changePasswordForm.newPassword === changePasswordForm.confirmNewPassword
  const submitEnabled = newPasswordFulfilledRules.length === passwordRules.length && validConfirmNewPassword

  useEffect(() => {
    if (modalRouteToDashboardState && loginDatas?.status_code === 200) {
      const accesses = loginDatas?.data?.user?.access?.filter(access =>
        access?.device?.some(d => d.device === device)
      )
      if (!accesses) {
        if (uuidRegex.test(loginDatas?.data?.token)) return
        setLoadingChangePassword(false)
        setModalChangePasswordState(false)
        setModalRouteToDashboardState(false)
        return
      }
      
      if (accesses.length > 1) {
        saveUserDataAndToken()
        router.push(`/home`)
        return
      }

      const directAccess = accesses?.[0]
      if (!directAccess) {
        setLoadingChangePassword(false)
        setModalChangePasswordState(false)
        setModalRouteToDashboardState(false)
        return
      }
      
      const routeDevice = directAccess?.device?.find(d => d.device === device)
      saveUserDataAndToken()
      setTimeout(() => 
        router.push(`${routeDevice.main_url}${routeDevice.uri}`)
      , 2000)
    }
  }, [loginDatas]);

  function saveUserDataAndToken() {
    if (typeof window !== undefined) {
      localStorage.setItem('data', JSON.stringify(loginDatas?.data?.user))
    }
    const cookie = new Cookies()
    cookie.set('user', loginDatas?.data?.token, {
      path: '/',
      expires: new Date(loginDatas?.data?.expire),
      secure: true,
    })
    cookie.set('userData', loginDatas?.data?.user, {
      path: '/',
      expires: new Date(loginDatas?.data?.expire),
      secure: true,
    })
  }

  const handleCloseModal = () => {
    if (!modalChangePasswordState) return
    dispatch(resetLoginData())
    setModalChangePasswordState(false)
  }

  const handleSubmit = async () => {
    if (loadingChangePassword) return
    setLoadingChangePassword(true)
    await postChangePasswordSvc({
      payload: {
        key: loginDatas.data.token,
        password: encode(changePasswordForm.newPassword),
        confirm_password: encode(changePasswordForm.confirmNewPassword),
      },
    })
    .then(() => {
      setLoadingChangePassword(false)
      setModalChangePasswordState(false)
      setModalRouteToDashboardState(true)
      dispatch(loginAction({
        password: encode(changePasswordForm.newPassword),
        personal_number: loginDatas.data.user.pernr,
        captcha_id: captchaContent?.data?.id,
        captcha_value: captchaValue,
      }))
    })
    .catch(() => {
      setLoadingChangePassword(false)
    })
  }

  const handleChangeNewPassword = (value: string) => {
    setChangePasswordForm({ ...changePasswordForm, newPassword: value })
  }

  const handleChangeConfirmNewPassword = (value: string) => {
    setChangePasswordForm({ ...changePasswordForm, confirmNewPassword: value })
  }

  const handleToggleMaskPassword = () => {
    setIsMaskPassword(prev => !prev)
  }

  const handleToggleMaskConfirmPassword = () => {
    setIsMaskConfirmPassword(prev => !prev)
  }

  if (modalRouteToDashboardState) {
    return (
      <Modal open={modalRouteToDashboardState} disableOutside >
        <Paper padding={"32px 24px"} height={400} width={383}>
          <div className={style["route-dashboard-wrapper"]}>
            <img
              src={`${process.env.NEXT_PUBLIC_IMAGES}/lock-success.webp`}
              width={"335px"}
            />
            <div className={style["route-dashboard-caption"]}>
              <Typography variant="title-4-bold" color="dark40" align="center">
                Password Berhasil Diganti!
              </Typography>
              <Typography variant="body-3-medium" color="dark20" align="center">
                Mohon tunggu sebentar, kami akan membawa Anda menuju halaman WISE 
              </Typography>
            </div>
          </div>
        </Paper>
      </Modal>
    )
  }

  return (
    <Modal open={modalChangePasswordState} handleOutside={handleCloseModal}>
      <Paper width={804} padding={"24px"} >
        <div className={style["paper-wrapper"]}>
          <div className={style["title-caption"]}>
            <Typography variant="title-4-bold" color="dark40">
              {`Selamat Datang${loginDatas?.data?.user?.name ? `,${loginDatas?.data?.user?.name}` : ""}!`}
            </Typography>
            <Typography variant="body-3-medium" color="dark20">
              Demi keamanan Anda, kami merekomendasikan untuk membuat password baru menggantikan password sementara yang dibuat oleh sistem.
            </Typography>
          </div>
          <div className={style["content"]}>
            <div className={style["information-box"]}>
              <div className={style["info-icon-wrapper"]}>
                <SubstractIcon color="#1078CA" size="16.67" rotate="180"/>
              </div>
              <div className={style["rules-container"]}>
                <Typography variant="body-3-bold" color="gray-2">
                  Perhatikan aturan berikut!
                </Typography>
                {
                  passwordRules.map((rule, index) => {
                    return (
                      <div 
                        key={rule}
                        className={style["rule-wrapper"]}
                      >
                        <div className={style["check-icon-wrapper"]}>
                          <ChecklistBrilink outerColor={newPasswordFulfilledRules.includes(index) ? "#27AE60" : "#777777"} checklistColor="#FFF" size="10.5"/>
                        </div>
                        <Typography variant="caption-1-medium" color="gray-2">
                          {rule}
                        </Typography>
                      </div>
                    )
                  })
                }
              </div>
            </div>
            <form
              className={style["form-container"]}
              onSubmit={(e) => {
                e?.preventDefault();
                handleSubmit();
              }}
            >
              <div className={style["input-container"]}>
                <Textfield
                  id={"TextField_NewPassword"}
                  type={isMaskPassword ? 'password' : 'text'}
                  label="Password Baru"
                  placeholder="Masukkan password baru"
                  value={changePasswordForm.newPassword}
                  onChange={e => handleChangeNewPassword(e.target.value)}
                  endAdornment={<Icon select={isMaskPassword ? 'eye_close' : 'eye_open'} size="18" color="#777777" rotate="0" />}
                  onEndAdornment={handleToggleMaskPassword}
                />
                <Textfield
                  id={"TextField_ConfirmNewPassword"}
                  type={isMaskConfirmPassword ? 'password' : 'text'}
                  label="Konfirmasi Password Baru"
                  placeholder="Konfirmasi password baru"
                  helperText={changePasswordForm.confirmNewPassword && !validConfirmNewPassword ? helperTextConfirmNewPassword : ''}
                  helperTextColor="red80"
                  isError={changePasswordForm.confirmNewPassword && !validConfirmNewPassword}
                  value={changePasswordForm.confirmNewPassword}
                  onChange={e => handleChangeConfirmNewPassword(e.target.value)}
                  endAdornment={<Icon select={isMaskConfirmPassword ? 'eye_close' : 'eye_open'} size="18" color="#777777" rotate="0" />}
                  onEndAdornment={handleToggleMaskConfirmPassword}
                />
              </div>
              <Button
                id={"Button_ChangePassword"}
                type="submit"
                enabled={submitEnabled}
              >
                <Typography
                  variant="body-3-bold"
                  color={submitEnabled ? "white" : "light60"}
                >
                  SIMPAN
                </Typography>
              </Button>
            </form>
          </div>
        </div>
      </Paper>
    </Modal>
  )
}
